import { useState } from "react";

export function Drop_down_selection({ setTeamDetails, teamKey, original }) {
  const options = ["DEFAULT VALUES", "GG", "OVR2_5", "UND2_5", "HOME"];
  const [selected, setSelected] = useState("");
  console.log("walky", original);
  const filters = {
    //DEFAULT: (original) => true,
    GG: (original) => original.Home_score > 0 && original.Away_score > 0,
    OVR2_5: (original) => original.Home_score + original.Away_score >= 3,
    UND2_5: (original) => original.Home_score + original.Away_score <= 2,
    HOME: (original) => original.Home_score > original.Away_score,

    "": () => true,
  };

  // Handle dropdown change
  const handleChange = (e) => {
    const value = e.target.value;
    setSelected(value);

    const filterFn = filters[value] || (() => false);
    const filtered = (original || []).filter(filterFn);

    if (value === "DEFAULT VALUES") {
      setTeamDetails((prev) => ({
        ...prev,
        [teamKey]: original || [],
      }));
      return;
    }
    setTeamDetails((prev) => ({
      ...prev,
      [teamKey]: filtered,
    }));
  };

  return (
    <div style={{ width: "200px" }}>
      {/* Dropdown */}
      <select
        value={selected}
        onChange={handleChange}
        style={{ width: "100%", padding: "5px", marginBottom: "10px" }}
      >
        {options.map((option, index) => (
          <option key={index} value={option}>
            {option}
          </option>
        ))}
      </select>

      {/* Show selection */}
      {selected && <div>Selected: {selected}</div>}
    </div>
  );
}
